import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ButtonComponent } from 'ui-library';

@Component({
  selector: 'app-edit-modal',
  imports: [
    TranslateModule,
    MatDialogModule,
    CommonModule,
    ButtonComponent,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule
  ],
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditModalComponent implements OnInit, OnDestroy {
  form: any;
  value: string = "";
  name: string = "";
  destroy$ = new Subject<void>();

  constructor(public fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditModalComponent>) { }

  ngOnInit(): void {
    this.name = this.data.name;
    this.value = this.data.value;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit() {
    this.dialogRef.close({ value: this.value, updated: this.value != this.data.value });
  }

  onCancel() {
    this.dialogRef.close({ updated: false });
  }
}
